/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */

import { combineDateTime } from 'utils/dateUtil';
import { convertDateForMappingQuestion } from '../../../utils/dateUtil';
import { defaultCountry } from './claimCodeMapper';

function getSelectedCountry(data) {
  if (!data.country) {
    return !!data.selectedCountry && typeof data.selectedCountry.toJS === 'function'
      ? data.selectedCountry.toJS()
      : data.selectedCountry;
  }
  return {
    id: data.country.id,
    value: data.country.name ? data.country.name : data.country.value,
    label: data.country.name ? data.country.name : data.country.value,
  };
}

function getCity(data) {
  if (!data.city) return '';
  if (typeof data.city.toJS === 'function') {
    return data.city.toJS().label;
  }
  return data.city.value || '';
}

function getProvinceLabel(data) {
  if (!data.provinceObject) return data.province || '';
  const po = typeof data.provinceObject.toJS === 'function'
    ? data.provinceObject.toJS()
    : data.provinceObject;
  return po.label || data.province || '';
}

function mapToParentSection(data, isVisibleDuesProtect, dateDuesProtect, defaultCity) {
  let incidentDate = '';
  let city = '';
  let location = '';
  let countryID = '';
  const selectedCountry = getSelectedCountry(data);

  if (isVisibleDuesProtect) {
    incidentDate = combineDateTime(dateDuesProtect, '');
    city = defaultCity;
    countryID = defaultCountry.id;
    location = city ? `${city}, ${defaultCountry.name}` : defaultCountry.name;
  } else {
    incidentDate = combineDateTime(data.dateOfEvent, data.timeOfEvent);
    city = getCity(data);
    countryID = (selectedCountry && selectedCountry.id) ? selectedCountry.id : '';
    location = city
      ? `${city}, ${(selectedCountry && selectedCountry.value) ? selectedCountry.value : ''}`
      : (selectedCountry && selectedCountry.value) ? selectedCountry.value : '';
  }
  const reportDate = new Date();
  const description = `${data.storyEvent}`;
  const selectedClaimForArray = data.selectedClaimFor ? (!Array.isArray(data.selectedClaimFor)) ? data.selectedClaimFor.toJS() : data.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.id);
  return {
    incidentDate,
    reportDate,
    incidentLocation: location,
    description,
    city,
    countryID,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
    usePrimaryEmailAddress: data.usePrimaryMemberEmailAddressForAllMember,
    province: getProvinceLabel(data),
    originalDepartureDate: convertDateForMappingQuestion(data.dateScheduledToDepart),
    originalReturnDate: convertDateForMappingQuestion(data.dateOriginallyScheduled),
    symptomsDate: convertDateForMappingQuestion(data.dateSymptomsStarted),
  };
}

function mapToQuestionnaire(data, claimCode, isVisibleDuesProtect) {
  let questions = [];
  let selectedCountry = null;
  if (data.country === undefined) {
    selectedCountry = !!data.selectedCountry && typeof data.selectedCountry.toJS === 'function' ? data.selectedCountry.toJS() : data.selectedCountry;
  } else {
    selectedCountry = data.country;
  }
  if (isVisibleDuesProtect === true) {
    questions = [];
  } else {
    questions = [
      {
        question: 'section4.country',
        answer: selectedCountry.id,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.province',
        answer: getProvinceLabel(data),
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.city',
        answer: !!data.city ? `${typeof data.city.toJS === 'function' ? data.city.toJS().label : (!!data.city.value ? data.city.value : '')}` : '',
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.storyEvent',
        answer: data.storyEvent,
        claimTypeCode: claimCode,
      },
      // {
      //   question: 'section4.totalAmount',
      //   answer: data.totalAmount,
      //   claimTypeCode: claimCode,
      // },
      // {
      //   question: 'section4.isClaimToInjuryOrIllness',
      //   answer: data.isClaimToInjuryOrIllness,
      //   claimTypeCode: claimCode,
      // },
      {
        question: 'section4.title',
        answer: data.title,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.firstName',
        answer: data.firstName,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.surName',
        answer: data.surName,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.dateOfBirth',
        answer: data.dateOfBirth,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.relationshipToYou',
        answer: data.relationshipToYou,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.dateYouFirstBecomeAware',
        answer: data.dateYouFirstBecomeAware,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.injuryOrIllnessOccorredBefore',
        answer: data.injuryOrIllnessOccorredBefore,
        claimTypeCode: claimCode,
      },
      {
        question: 'section4.detailOfMedicalCondition',
        answer: data.detailOfMedicalCondition,
        claimTypeCode: claimCode,
      },
      {
        question: 'section1.dateBookedTrip',
        answer: convertDateForMappingQuestion(data.dateBookedTrip),
        claimTypeCode: claimCode,
      },
      {
        question: 'section1.dateOriginallyScheduledDepart',
        answer: convertDateForMappingQuestion(data.dateScheduledToDepart),
        claimTypeCode: claimCode,
      },
      {
        question: 'section1.dateOriginallyScheduledReturn',
        answer: convertDateForMappingQuestion(data.dateOriginallyScheduled),
        claimTypeCode: claimCode,
      },
    ];
  }
  return questions;
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepWhatHappenedDataMapper.js